class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.optionInputs = this.querySelectorAll("variant-selects input[type='radio']");
    this.optionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        if( !input.checked ) return;
        this.onOptionChange(input.dataset.variantId)});
    });
  }

  onOptionChange(variantId) {
    const url = new URL(window.location);
    url.searchParams.set("variant", variantId);
    const urlToChange = url.toString();
    url.searchParams.set("section_id", this.dataset.sectionId);
    fetch(url.toString()).then(response => {
      return response.text();
    }).then(doc => {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(doc, "text/html");
      const newProductInfo = htmlDoc.querySelector("product-info");
      this.replaceWith(newProductInfo);
      window.history.replaceState({}, "", urlToChange);
    })
  }
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", ProductInfo);
}